<div class="box">
  <div class="modal-body">
    <div class="modal-info">
      <fa-icon [icon]="icon" class="modal-info-icon" />
      <div class="modal-info-content">
        <h2 class="modal-info-title">
          {{ 'USER_AGREEMENT_UPDATING_MODAL.TITLE' | translate }}
        </h2>
        <p class="modal-info-description">
          {{ 'USER_AGREEMENT_UPDATING_MODAL.DESCRIPTION' | translate }}
        </p>
      </div>
      <div class="checkbox">
        <input
          type="checkbox"
          id="user-agreement-updating-modal-individual-agreement"
          [ngModel]="isAgreedToUserAgreementUpdate()"
          (ngModelChange)="isAgreedToUserAgreementUpdate.set($event)"
        />
        <label
          class="user-agreement-updating-modal-individual-agreement"
          for="user-agreement-updating-modal-individual-agreement"
        >
          <div class="checkbox__el"></div>
          <div class="checkbox__desc">
            <span class="h5">
              {{ 'USER_AGREEMENT.TEXT' | translate }}
              <a
                class="user-agreement-link"
                (click)="navigateToUserAgreement($event)"
              >
                {{ 'USER_AGREEMENT.LINK' | translate }}
              </a>
            </span>
          </div>
        </label>
      </div>
    </div>
    <div class="modal-actions">
      <button
        type="button"
        class="button button--filled button--shadow"
        [disabled]="isUserAgreementUpdateDisabled()"
        (click)="confirm()"
      >
        {{ 'CONFIRM' | translate }}
      </button>
    </div>
  </div>
</div>
